import service from '@/utils/server';

const modName='/bd/accessoryUnload/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const uploadImport = data => {
  let config={    responseType: "blob"}
  return service({
    ...config,
    url: modName + 'uploadImport',
    method: 'post',
    data
  });
};

export function uploadUrl (){
  return  process.env.BASE_URL + `${modName}uploadImport`;
};

export const unloadDelete = data => {
  return service({
    url: modName + 'deleteUnload',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/accessory/unloadOrder/api/index.js